import { render } from "./XCSiteHomePage.vue?vue&type=template&id=65e1a294&scoped=true"
import script from "./XCSiteHomePage.vue?vue&type=script&lang=js"
export * from "./XCSiteHomePage.vue?vue&type=script&lang=js"

import "./XCSiteHomePage.vue?vue&type=style&index=0&id=65e1a294&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e1a294"]])

export default __exports__